module.exports = __webpack_public_path__ + "img/check-mark.21dd23c7.png";